import * as React from 'react';
import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Menu from '@mui/material/Menu';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import ClearIcon from '@mui/icons-material/Clear';
import NotificationsRoundedIcon from '@mui/icons-material/NotificationsRounded';
import MenuButton from './MenuButton';
import usePremiumNotice from '../../hooks/usePremiumNotice';

interface NotificationsMenuProps {
  'aria-label'?: string;
}

export default function NotificationsMenu({
  'aria-label': ariaLabel = 'Open notifications',
}: NotificationsMenuProps) {
  const { palette, typography } = useTheme();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const { showPremiumNotice, dismissPremiumNotice } = usePremiumNotice();

  return (
    <>
      <MenuButton
        showBadge={showPremiumNotice}
        aria-label={ariaLabel}
        onClick={handleClick}
      >
        <NotificationsRoundedIcon />
      </MenuButton>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          paper: {
            style: {
              maxHeight: 'calc(100dvh - 200px)',
              width: '400px',
              borderRadius: '8px',
              backgroundColor: palette.primary.light,
              color: palette.primary.contrastText,
            },
          },
        }}
      >
        <Box p={2}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography variant="h5" fontWeight={typography.h2.fontWeight}>
              Notifications
            </Typography>
            <IconButton onClick={handleClose}>
              <ClearIcon sx={{ color: palette.background.paper }} />
            </IconButton>
          </Box>
          {showPremiumNotice ? (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'flex-start',
                justifyContent: 'space-between',
                gap: 1,
                mt: 1,
              }}
            >
              <Typography variant="body1">
                You've unlocked premium features! Enjoy your enhanced
                experience.
              </Typography>
              <IconButton
                size="small"
                aria-label="Dismiss notification"
                onClick={dismissPremiumNotice}
              >
                <ClearIcon
                  fontSize="small"
                  sx={{ color: palette.background.paper }}
                />
              </IconButton>
            </Box>
          ) : (
            <Typography variant="body1">No notifications</Typography>
          )}
        </Box>
      </Menu>
    </>
  );
}
